<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    :class="['add-new-data-sidebar', 'items-no-padding', size]"
    spacer
    v-model="isSidebarActive"
  >
    <div :id="`loading-${name}-sidebar`" class="vs-con-loading__container">
      <div
        class="pt-4 px-4 flex items-center justify-between"
        :style="titleStyle"
      >
        <span class="sidebar-title">{{ title }}</span>
        <feather-icon
          icon="XIcon"
          @click.stop="close"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vue-perfect-scrollbar
        class="scroll-area--data-list-add-new"
        :settings="settings"
      >
        <div>
          <slot></slot>
        </div>
        <div class="items-center pt-2 mb-2">
          <slot name="footer"></slot>
        </div>
      </vue-perfect-scrollbar>

      <!-- <div class="flex flex-wrap items-center p-2"></div> -->
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  components: {
    VuePerfectScrollbar,
  },
  props: {
    title: {
      type: String,
      default: 'Title',
    },
    name: {
      type: String,
      default: 'main-sidebar',
    },
    size: {
      type: String,
      default: '',
    },
    titleStyle: {
      type: Object,
      default: () => ({}),
    },
    sidebarClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
      },
    }
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
  },
  methods: {
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
  },
  mounted() {
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        if (this.$store.state.popup === false) {
          this.close()
        }
      }
    })
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 450px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.sidebar-title {
  font-size: 18px;
}

.add-new-data-sidebar.large {
  ::v-deep .vs-sidebar {
    width: 800px;
  }
}

.add-new-data-sidebar.full {
  ::v-deep .vs-sidebar {
    width: 100%;
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  //height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
  height: 90vh;

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
